import { TESTIMONIALS_SERVICE } from "@/services/testimonials.service.js";

const state = {
    postTestimonialOutput: false,
    getTestimonialsOutput: {},
    putTestimonialsOutput: false,
    getTestimonialByIdOutput: {},
    deleteTestimonialByIdOutput: false
};

const actions = {
    //Service to create testimonial content
    postTestimonial({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postTestimonialRequest');

        TESTIMONIALS_SERVICE.postTestimonial(input)
            .then(
                output => {
                    commit('postTestimonialSuccess', output);
                },
                error => {
                    commit('postTestimonialFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get paginated testimonial content
    getTestimonials({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getTestimonialsRequest');

        TESTIMONIALS_SERVICE.getTestimonials(queryParams)
            .then(
                output => {
                    commit('getTestimonialsSuccess', output);
                },
                error => {
                    commit('getTestimonialsFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update testimonial content
    putTestimonial({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putTestimonialsRequest');

        TESTIMONIALS_SERVICE.putTestimonial(input)
            .then(
                output => {
                    commit('putTestimonialsSuccess', output);
                },
                error => {
                    commit('putTestimonialsFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get testimonial details.
    getTestimonialById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('getTestimonialByIdRequest');

        TESTIMONIALS_SERVICE.getTestimonialById(id)
            .then(
                output => {
                    commit('getTestimonialByIdSuccess', output);
                },
                error => {
                    commit('getTestimonialByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to delete testimonials
    deleteTestimonialById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('deleteTestimonialByIdRequest');

        TESTIMONIALS_SERVICE.deleteTestimonialById(id)
            .then(
                output => {
                    commit('deleteTestimonialByIdSuccess', output);
                },
                error => {
                    commit('deleteTestimonialByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    }
};

const mutations = {
    //postTestimonial
    postTestimonialRequest(state) {
        state.postTestimonialOutput = null;
    },
    postTestimonialSuccess(state, output) {
        state.postTestimonialOutput = true;
    },
    postTestimonialFailure(state) {
        state.postTestimonialOutput = false;
    },

    //getTestimonials
    getTestimonialsRequest(state) {
    },
    getTestimonialsSuccess(state, output) {
        state.getTestimonialsOutput = output;
    },
    getTestimonialsFailure(state) {
        state.getTestimonialsOutput = false;
    },

    //putTestimonial
    putTestimonialsRequest(state) {
        state.putTestimonialsOutput = null;
    },
    putTestimonialsSuccess(state, output) {
        state.putTestimonialsOutput = true;
    },
    putTestimonialsFailure(state) {
        state.putTestimonialsOutput = false;
    },

    //getTestimonialById
    getTestimonialByIdRequest(state) {
    },
    getTestimonialByIdSuccess(state, output) {
        state.getTestimonialByIdOutput = output;
    },
    getTestimonialByIdFailure(state) {
        state.getTestimonialByIdOutput = false;
    },

    //deleteTestimonialById
    deleteTestimonialByIdRequest(state) {
        state.deleteTestimonialByIdOutput = null;
    },
    deleteTestimonialByIdSuccess(state, output) {
        state.deleteTestimonialByIdOutput = true;
    },
    deleteTestimonialByIdFailure(state) {
        state.deleteTestimonialByIdOutput = false;
    }
};

export const testimonials = {
    namespaced: true,
    state,
    actions,
    mutations
};
